<template>
    <contentCardIndex >
        <template slot="cardContent">
                <v-row align="center">
                    <v-col cols="12" md="3" lg="3" class="mx-0 px-0">
                        <alternativeTextField2
                            @onChanged="(v) => {trySearch(v);}" 
                            :valueInput="tableProps.search"
                            :rule="[]"
                            :placeholder="'Buscar'"
                            :label="''"
                            :prependInnerIcon="'mdi-magnify'"
                            class="pick-3"
                            data-cy="search-input"
                        ></alternativeTextField2>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col   cols="12" md="3" lg="3" xl="2" class="mx-0 ">
                        <v-row justify="end">
                            <primaryButton data-cy="create-btn" :props="createBtnData"></primaryButton>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row class="mt-md-0">
                    <v-col class="mx-0 px-0">
                        <datatable data-cy="index-table" :props="tableProps" @methodHandler="method_handler">
                        
                        </datatable>
                    </v-col>
                </v-row>
                <!-- DELETE MODAL -->
                <modal data-cy="index-modal" :props="modalProps" @modalResponse="method_handler">
                    <!-- Buttons -->
                    <template slot="cardActions">
                        <v-row justify="end" data-cy="index-modal-actions">
                            <v-col cols="12" sm="4">
                                <secondaryButton
                                data-cy="cancel-modal-btn"
                                :props="cancelModal"
                                ></secondaryButton>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <primaryButton
                                data-cy="accept-modal-btn"
                                :props="acceptModal"
                                ></primaryButton>
                            </v-col>
                        </v-row>
                    </template> 
                </modal>
                <!-- MODAL EMAIL -->
                <modal :props="modalMailProps" @modalResponse="method_handler">
                    <template slot="cardBody">
                        <p>
                            Al aceptar será enviado un correo con la cotización 
                            adjunta a la cuenta <span class="font-weight-black">{{clientEmail}}</span> 
                            para <span class="font-weight-black">{{clientName}}</span> 
                        </p>
                    </template>
                    <!-- Buttons -->
                    <template slot="cardActions">
                        <v-row justify="end" data-cy="index-modal-actions">
                            <v-col cols="12" sm="4">
                                <secondaryButton
                                data-cy="cancel-modal-btn"
                                :props="cancelMailModal"
                                ></secondaryButton>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <primaryButton
                                data-cy="accept-modal-btn"
                                :props="acceptMailModal"
                                ></primaryButton>
                            </v-col>
                        </v-row>
                    </template> 
                </modal>
        </template>

        
    
    </contentCardIndex>

        
</template>
<script>
import Utils from '../../../helpers/Utils'
export default {
    data(){
		return {
            clientName:"",
            clientEmail: "",
           
			search: '',
            selectedID: '',
			actions: [
               
				{
					name: 'Detalles',
					icon: {
						color: 'primary',
						icon: 'mdi-information-outline',
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'products.edit',
                    dataCy: "details-link"
				},
                {
					name: 'Editar',
					icon: {
						color: 'primary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'products.edit',
                    dataCy: "edit-link"
				},
               
				{
					name: 'Borrar',
					icon: {
						color: 'primary',
						icon: 'mdi-delete-outline',
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteItemModal',
                    permissions: 'products.delete',
                    dataCy: "delete-link"
				},

                {
					name: 'Enviar correo',
					icon: {
						color: 'primary',
						icon: 'mdi-email-arrow-right-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'openModalMail',
                    permissions: 'products.show',
                    dataCy: "send-link",
                    loading: false,
				},

                {
					name: 'Copiar',
					icon: {
						color: 'primary',
						icon: 'mdi-content-copy'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'products.edit',
                    dataCy: "copy-link"
				},

                {
					name: 'Imprimir',
					icon: {
						color: 'primary',
						icon: 'mdi-printer-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'getPdf',
                    permissions: 'products.delete',
                    dataCy: "pdf-link"
				},

                {
					name: 'Orden de trabajo',
					icon: {
						color: 'primary',
						icon: 'mdi-file-document-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'products.edit',
                    dataCy: "odt-link"
				},

			],
			tableProps: {
				headers: [
                    {
						text: 'OT',
						align: 'left break-words',
						value: 'work.folio',
                        width: "9%",
						class: 'table-b-border black--text'
					},
                    {
						text: 'Fecha',
						align: 'center break-words',
						value: 'date',
                        width: '10%',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Cliente',
						align: 'center break-words',
						value: 'client.name',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Subtotal',
						align: 'center break-words',
						value: 'subtotal',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Iva',
						align: 'center break-words',
						value: 'iva',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Total',
						align: 'center break-words',
						value: 'total',
						class: 'table-b-border black--text'
					},
					{
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '15%',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: '',
				loading: false
			},
			
			
            createBtnData: {
                text: "Nueva cotización",
                icon: "mdi-plus",
				to: "QuotationsCreate",
				block: false,
                click: ()=>{}
            },

			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			
			cancelModal: {
                text: "No, cancelar",
                icon: "",
				to: "",
				block: true,
				color: '',
                cy:"cancel-modal-btn",
                click: ()=>{this.modalProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
                textColorLevel: '0',
				loading:false,
                cy:"accept-modal-btn",
                click: ()=>{this.delete()}
            },

            modalMailProps: {
				visible: false,
				width: '500',
				title: 'Enviar correo',
				text: '',
				loading: false,
				bottomLineColor: '',
				
			},
			
			cancelMailModal: {
                text: "Cancelar",
                icon: "",
				to: "",
				block: true,
				color: '',
                cy:"cancel-modal-btn",
                click: ()=>{this.modalMailProps.visible = false}
            },
			acceptMailModal: {
                text: "Aceptar",
                icon: "",
				to: "",
				block: true,
				color: 'primary',
				textColor:'white',
                textColorLevel: '0',
				loading:false,
                cy:"accept-modal-btn",
                click: ()=>{this.sendMail()}
            },
		}
	},

	mounted(){
		this.index();
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
	},

    methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},
        onResize () {
            
            if(window.innerWidth < 960){
                this.createBtnData.block = true;
                
            }
            else{
                this.createBtnData.block = false;
                
            }
        },
      
        trySearch(val){
            this.tableProps.search = val;
        },
		index() {
			this.tableProps.loading = true;
           
			// call api
			this.$api.quotation.list()
				.then((resp) =>{
					//console.log(resp);
					this.tableProps.items = resp.data.reverse().map((x,i) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actions))
                       
						
                        x.actions[0].action = { name: 'QuotationsDetails', params: { id: x.id } }
                        x.actions[1].action = { name: 'QuotationsEdit', params: { id: x.id } }
                        x.actions[4].action = { name: 'QuotationsCreate', params: { id: x.id } }
                        x.actions[6].action = { name: 'SaleOrdersCreate', params: { quotationId: x.id } }

                        x.actions[6].disabled = x.has_sale_order == 1 ? true : false;
						

						x['parameters'] = { id: x.id, name: x.work.folio, index: i, client: x.client.name, email: x.client.email};
                        x.date = Utils.globalDateFormat(x.date)
                        x.subtotal = Utils.currencyFormat(x?.subtotal??"", "");
                        x.iva = Utils.currencyFormat(x?.iva??"", "");
                        x.total = Utils.currencyFormat(x?.total??"", "");
                       
						return x;
					});
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		
		},



		deleteItemModal(parameters)
		{
			//console.log(parameters);
			this.selectedID = parameters.id;
			this.modalProps = {
				...this.modalProps,
				text: `¿Estás seguro de eliminar "${parameters.name}"?`,
				
			}
            console.log(this.selectedID)
			this.modalProps.visible = true;
			
		},


		delete()
		{
			//console.log(this.selectedID);
			this.acceptModal.loading = true;
			this.$api.quotation.delete(this.selectedID)
			// eslint-disable-next-line
			.then((response) => {
				
				this.$store.dispatch('snackbarSuccess', `Se ha eliminado`);
				this.index()
				// eslint-disable-next-line
			}).catch(error => {
				if(error.response.status === 422){
                    this.$store.dispatch('snackbarError', `${error.response.data.error??'Error al eliminar'}`);
                }else{
                    this.$store.dispatch('snackbarError', `Error al eliminar. Intenta de nuevo`);
                }

				
			})
			.finally(() => {
				this.modalProps.visible = false;
				this.acceptModal.loading = false;
			})
		},


        getPdf(parameters)
		{
            this.selectedID = parameters.id;
            this.tableProps.items[parameters.index].actions[5].loading = true
			//console.log(this.selectedID);
			this.$api.quotation.pdf(this.selectedID)
                // eslint-disable-next-line
                .then((response) => {
                    console.log(response);
                    let file = new Blob([response.data], {type: 'application/pdf'});
                    let fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    // eslint-disable-next-line
                }).catch(error => {
                    if(error.response.status === 422){
                        this.$store.dispatch('snackbarError', `${error.response.data.error??'Error al obtener archivo'}`);
                    }else{
                        this.$store.dispatch('snackbarError', `Error. Intenta de nuevo`);
                    }

                    
                })
                .finally(() => {
                    this.tableProps.items[parameters.index].actions[5].loading = false;
                })
            ;
		},


        openModalMail(parameters)
        {
            this.selectedID = parameters.id;
            this.clientName = parameters.client;
            this.clientEmail = parameters.email;

            this.modalMailProps.visible = true;
        },

        sendMail()
        {
            // this.selectedID = parameters.id;
            // this.tableProps.items[parameters.index].actions[2].loading = true
            this.acceptMailModal.loading = true;
			//console.log(this.selectedID);
			this.$api.quotation.sendMail(this.selectedID)
                // eslint-disable-next-line
                .then((response) => {
                    this.$store.dispatch('snackbarSuccess', `El correo ha sido enviado correctamente a ${this.clientName}`);
                    // eslint-disable-next-line
                }).catch(error => {
                    if(error.response.status === 422){
                        this.$store.dispatch('snackbarError', `${error.response.data.error??'Error al enviar'}`);
                    }else{
                        this.$store.dispatch('snackbarError', `Error. Intenta de nuevo`);
                    }

                    
                })
                .finally(() => {
                    this.acceptMailModal.loading = false;
                    this.modalMailProps.visible = false;
                    // this.tableProps.items[parameters.index].actions[2].loading = false;
                })
            ;
        }

    }
}
</script>